module.exports = __webpack_public_path__ + "static/media/iconDj.684635c1.svg";